/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalQuestionDataTypeSchema = z.enum(['select', 'text', 'open_text', 'file', 'datetime'])

export type AdditionalQuestionDataTypeSchema = z.infer<typeof additionalQuestionDataTypeSchema>
